// const { getGraphQL } = require('../api');

export default {
  setState ({ commit }, params) {
    commit(params.commitTo, params.data[params.request]);
  }
};
